import { BodyLinkV3 } from '@jouzen/ecom-components';
import type { MouseEventHandler, ReactNode } from 'react';

export const tValueBestBuy = {
  a: function a(chunks: ReactNode) {
    return <BodyLinkV3 href="/best-buy/store-locator">{chunks}</BodyLinkV3>;
  },
};

export const tValueSizing = (
  onSizeLinkClick: MouseEventHandler<HTMLAnchorElement>,
) => ({
  a: function a(chunks: ReactNode) {
    return (
      <BodyLinkV3
        className="text-burntOrange"
        href="https://ouraring.com/sizing"
        target="_blank"
        onClick={onSizeLinkClick}
      >
        {chunks}
      </BodyLinkV3>
    );
  },
});
